module.exports = __webpack_public_path__ + "img/left.198aab74.png";